import{renderIcon as o}from"../icon.renderer.js";const e="node",n=["node",o({outline:'<path d="M18,30.66,7,24.33V11.67L18,5.34l11,6.33V24.33ZM9,23.18l9,5.17,9-5.17V12.82L18,7.65,9,12.82Z"/>'})];export{n as nodeIcon,e as nodeIconName};
